import { equals, props, unionWith } from 'ramda';
import { handleActions } from 'redux-actions';

import { createStandardTableReducer } from 'utils';

import { NAME } from './constants';

const { actionTypes, actions, selectors } = createStandardTableReducer(NAME);

export { actionTypes, actions, selectors };

const emptyArray = [];

const merge = (state, sellers) => {
	const compare = props(['channelId', 'regionId', 'agencyId', 'manager', 'login']);
	return unionWith((s, f) => equals(compare(s), compare(f)), state, sellers);
};

const tableReducer = {
	[actionTypes.SET_TABLE_DATA]: (state, { payload }) => [...payload.data],
	[actionTypes.APPEND_TABLE_DATA]: (state, { payload }) => merge(state, payload.data),
	[actionTypes.RESET_TABLE_DATA]: () => emptyArray,
};

export default handleActions(tableReducer, emptyArray);
